import { render } from "./FooterVue.vue?vue&type=template&id=7f6aa654&scoped=true"
const script = {}

import "./FooterVue.vue?vue&type=style&index=0&id=7f6aa654&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6aa654"]])

export default __exports__